import * as React from "react";
import PropTypes from 'prop-types';

const SvgRewardsFill = props => {
  if (props.id !== "_svgrewardsfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm.909 5.386h-1.465l.055 1.404c-1.538.256-2.747 1.319-2.747 2.931 0 1.392.86 2.197 2.27 2.857l.954.421c1.171.531 1.868.916 1.868 1.759 0 .787-.55 1.391-1.868 1.391-1.264 0-2.272-.622-2.766-1.08l-.989 1.337c.458.403 1.428 1.062 3.077 1.191l-.019 1.017h1.465l-.055-1.072c1.942-.293 2.876-1.594 2.876-2.949 0-1.521-.97-2.198-2.509-2.876l-.825-.366c-1.062-.476-1.757-.916-1.757-1.777 0-.824.622-1.337 1.721-1.337.825 0 1.612.348 2.088.787l1.026-1.3c-.348-.311-1.154-.842-2.4-.971V9.386z" /></svg>;
};

SvgRewardsFill.displayName = "_svgrewardsfill";
SvgRewardsFill.propTypes = {
  id: PropTypes.string
};
SvgRewardsFill.defaultProps = {
  id: ''
};
export default SvgRewardsFill;